import { InjectionToken } from '@angular/core';

export const FALLBACK_PAGENAME = new InjectionToken('Fallback pagename used in pageViewData', {
    factory: () => 'Overview'
});
